import type * as Guide from '../../../shared/domain/guides/types.no-deps'
import type { Replace } from '../../../shared/lib/typeHelpers.no-deps'
import type { Endpoint, Route, Request, RequestArgs } from '../types.no-deps'

export const route: Route = { method: 'POST', pattern: '/api/guides/bulk' }

export type UpdateGuideParams = Replace<
    Pick<Guide.UpdateGuideParams, 'procedures' | 'tags' | 'units'>,
    { tags?: string[] }
>

type Params = never
type Body = {
    guides: Array<{
        guide: Guide.Id
        params: UpdateGuideParams
    }>
}
type Query = never
type Output = { guides: Guide.SyncGuide[] }

export type EditGuidesBulkEndpoint = Endpoint<Params, Body, Query, Output>

export const editGuidesBulkRequest = (request: Request, args: RequestArgs<EditGuidesBulkEndpoint>) =>
    request<EditGuidesBulkEndpoint>(route, args)
